// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:15:42.827Z
// Property: Villas at Countryside Apartment Homes (ID: 6767906449167073)
// Collections: 25 amenities, 4 floorplans (live), 20 photos, 42 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167073",
  "property_external_id": "1440848",
  "property_zillow_url": "https://www.zillow.com/apartments/moore-ok/villas-at-countryside-apartment-homes/5hQvhW/",
  "property_apartments_url": "https://www.apartments.com/villas-at-countryside-moore-ok/qwqfr2z/",
  "property_google_business_url": "https://www.google.com/maps/place/Villas+at+Countryside/data=!4m2!3m1!1s0x0:0xf02bb1e66731ed7?sa=X&ved=2ahUKEwjn9s7Kr4OTAxX6AzQIHb1-IGcQ_BJ6BAhBEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "55606342929",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "villas-at-countryside-apartment-homes",
  "property_name": "Villas at Countryside Apartment Homes",
  "property_website_url": "https://www.thevillasatcountryside.com",
  "property_domain": "https://www.thevillasatcountryside.com",
  "property_address": "9501 S I-35 Service Rd",
  "property_full_address": "9501 S I-35 Service Rd, Moore, OK, 73160",
  "property_address_1": "9501 S I-35 Service Rd",
  "property_address_2": null,
  "property_address_city": "Moore",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73160",
  "property_address_country": "US",
  "property_address_county": "Cleveland",
  "property_neighborhood_address": "South Oklahoma City",
  "property_address_latitude": "35.372",
  "property_address_longitude": "-97.496",
  "property_email": "countryside@Weidner.com",
  "property_phone": "14057595434",
  "property_call_tracking_phone": "405-759-5434",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Countryside in Moore, OK, where modern comfort meets vibrant community living. Choose from stylish one and two-bedroom floor plans, complete with luxurious amenities like a fitness center, relaxing sundeck, and cozy clubhouses. Elevate your lifestyle—browse our availability and schedule a tour today!",
  "property_long_description": "**Discover Your New Home at Countryside Apartments in Moore, OK**\n\nWelcome to Countryside Apartments, where comfort meets convenience in the heart of Moore, OK. Our thoughtfully designed community offers a variety of spacious floor plans, including one and two-bedroom options, ensuring you find the perfect fit for your lifestyle. Enjoy the luxury of furnished units available through CORT, flexible lease terms, and the convenience of online rent payment.\n\nCountryside boasts an array of premium amenities designed to enhance your living experience. Unwind after a long day in our inviting clubhouse or lounge, or take a refreshing dip in the sparkling pool. Our state-of-the-art fitness center and sundeck provide the perfect spaces for relaxation and rejuvenation, while our picnic areas with charcoal grills and grilling pavilion invite you to enjoy the outdoors—perfect for gatherings with family and friends.\n\nFor pet lovers, our pet park with convenient pet stations ensures your furry friends have a space to roam and play freely. Rest easy knowing our on-site maintenance team is always available to assist you, and enjoy the convenience of in-home washers and dryers in select units.\n\nEach apartment features modern touches, including vaulted ceilings, walk-in closets, and spacious kitchens with ample storage. Enjoy added comforts such as high-speed internet access, air conditioning, and the option to upgrade to a fireplace or private patio/balcony.\n\nJoin our smoke-free community at Countryside and experience life where comfort meets style. **Find your new home today—browse our availability or schedule a tour to visit our vibrant community!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b1-767f-75ee-b902-0a30fa731cd2.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings with manicured lawns and walkways",
    "public_id": "019d01b1-767f-75ee-b902-0a30fa731cd2",
    "storage_key": "property/6767906449167073/019d01b1-767f-75ee-b902-0a30fa731cd2.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "361",
  "property_year_built": "2002",
  "property_year_renovated": null,
  "property_walk_score": "43",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.67590027700831",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "300-varies",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://thevillasatcountryside.securecafe.com/onlineleasing/villas-at-countryside-0/floorplans.aspx",
  "property_resident_portal_url": "https://thevillasatcountryside.securecafenet.com/residentservices/villas-at-countryside-0/userlogin",
  "property_apply_now_url": "https://thevillasatcountryside.securecafe.com/onlineleasing/villas-at-countryside-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b1-7ff4-7096-95a6-f24d56459703.webp",
  "property_primary_logo_media": {
    "alt_text": "Villas at Countryside Apartment Homes logo",
    "public_id": "019d01b1-7ff4-7096-95a6-f24d56459703",
    "storage_key": "property/6767906449167073/019d01b1-7ff4-7096-95a6-f24d56459703.webp",
    "width": 255,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b1-8861-777c-b28d-444c13b6d36d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Villas at Countryside Apartment Homes logo",
    "public_id": "019d01b1-8861-777c-b28d-444c13b6d36d",
    "storage_key": "property/6767906449167073/019d01b1-8861-777c-b28d-444c13b6d36d.webp",
    "width": 255,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b1-909f-7318-a0cc-f03895f7416e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Villas at Countryside logo",
    "public_id": "019d01b1-909f-7318-a0cc-f03895f7416e",
    "storage_key": "property/6767906449167073/019d01b1-909f-7318-a0cc-f03895f7416e.webp",
    "width": 255,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#798696",
  "property_secondary_color": "#a89783",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "800 - 1000",
  "property_sqft_min": "800",
  "property_sqft_max": "1000",
  "property_price_range": "885 - 2070",
  "property_price_min": "885",
  "property_price_max": "2070",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/VillasAtCountrysideApartments",
  "property_instagram_url": "https://www.instagram.com/villasatcountrysideapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJrdZtHfQUsocR1x5zZh67Ag8",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": "https://www.tiktok.com/discover/villas-at-countryside-moore-oklahoma-apartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Countryside",
  "property_home_romance_title": "Embrace Your Ideal Lifestyle in Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Countryside in Moore, OK, where comfort meets style. Choose from spacious one and two-bedroom apartments featuring modern amenities like in-home washers and dryers, furnished units, and a pet-friendly park. Enjoy our vibrant community spaces, including a fitness center, clubhouse, and sundeck, all designed for your ultimate convenience and relaxation.",
  "property_home_floorplans_blurb": "Nestled in the heart of Moore, OK, Countryside offers spacious floor plans designed for modern living. With a blend of comfort and convenience, each apartment home provides a unique sanctuary. Browse our available options today and begin your journey to a vibrant lifestyle in the perfect space that reflects you!",
  "property_home_gallery_blurb": "At Countryside in Moore, OK, your dream apartment awaits! Choose from stylish one or two-bedroom floor plans, each designed for comfort and convenience. Enjoy lavish amenities like a pool, fitness center, and pet park. Picture yourself unwinding on your private balcony or gathering in the vibrant clubhouse!",
  "property_home_neighborhood_blurb": "Welcome to Countryside, where your new home in Moore, OK, offers not just stylish one and two-bedroom floor plans, but easy access to enriching experiences. Enjoy nearby cultural spots like the Museum of Osteology, First Americans Museum, and the serenity of Scissortail Park. Dive into a vibrant community with something for everyone!",
  "property_home_reviews_blurb": "At Countryside in Moore, OK, residents rave about their experience, saying, \"The community feels like home, with friendly neighbors and beautiful surroundings.\" Join our vibrant community today and see what makes Countryside the perfect place to live. Let our residents' words inspire your next home! ",
  "property_neighborhood_blurb": "Nestled in the heart of Moore, OK, Countryside offers more than just stunning one and two-bedroom floor plans. Enjoy nearby attractions like the Museum of Osteology, Scissortail Park, and the bustling Oklahoma City Community College. Uncover the vibrant community that surrounds you and uncover local treasures just steps away.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Countryside in Moore, OK, elevate your living experience with our spacious one- and two-bedroom floor plans. Enjoy premium amenities like a sun-soaked sundeck, inviting clubhouse, and a pet park. With modern touches like farmhouse-style kitchen sinks and cozy fireplaces, your perfect home awaits—ready to welcome you in!",
  "property_applynow_blurb": "Welcome to Countryside in Moore, OK—a vibrant community where comfort meets convenience. Choose from spacious one and two-bedroom floor plans, complete with modern amenities like a fully equipped kitchen, in-home washer and dryer, and serene outdoor spaces. Experience effortless living; lease online today and embrace your new home!",
  "property_contactus_blurb": "At Countryside in Moore, OK, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Whether you're seeking a cozy retreat or extra space for living and entertaining, we have something for everyone. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Countryside in Moore, OK, we offer one and two-bedroom floor plans designed for comfort and style. Have questions about our community? Our FAQs page is your go-to resource for insights and answers, ensuring you find the perfect living experience tailored just for you!",
  "property_floorplans_blurb": "At Countryside in Moore, OK, our diverse floor plans cater to every lifestyle, offering both one-bedroom and two-bedroom apartments that blend comfort and functionality. Each layout is designed with you in mind. Browse our available apartment homes and find the perfect space that feels like home.",
  "property_gallery_blurb": "At Countryside in Moore, OK, envision your life amidst spacious one- and two-bedroom apartments that blend comfort and style. With luxurious amenities—from a refreshing pool and inviting clubhouse to cozy fireplaces and gourmet kitchens—this is where everyday living meets extraordinary. Picture yourself living here and embrace the charm!",
  "property_interactivemap_blurb": "At Countryside in Moore, OK, embrace a lifestyle filled with comfort and convenience. Choose from stylish one or two-bedroom apartments featuring spacious layouts, modern amenities, and a vibrant community. Utilize our interactive map to effortlessly navigate availability and pricing, ensuring your perfect home awaits just a click away!",
  "property_pets_blurb": "At Countryside in Moore, OK, your furry friends will feel right at home! With spacious apartments, a welcoming community, and pet-friendly policies, you can enjoy life with your beloved companions. Just keep in mind our breed restrictions as your pets settle into this vibrant neighborhood. ",
  "property_referafriend_blurb": "At Countryside in Moore, OK, your ideal living space awaits! Choose from stylish one or two-bedroom floor plans tailored for comfort and connection. Share the joy of great neighbors—refer a friend today and embrace a vibrant community where friendships flourish among beautiful surroundings and modern amenities.",
  "property_residentaccess_blurb": "At Countryside in Moore, OK, your ideal home awaits with thoughtfully designed one and two-bedroom floor plans. Enjoy seamless living with our resident portal—pay rent, schedule maintenance, and connect with our vibrant community easily. Make the most of your experience at Countryside today!",
  "property_reviews_blurb": "At Countryside in Moore, OK, our residents rave, \"the friendly atmosphere and spacious layouts make everyday life a joy!\" Feel the warmth of our community and the convenience of modern amenities. Don’t just take our word for it—see what our residents have to say about living at our community!",
  "property_created_at": "1771526438579",
  "property_scheduletour_blurb": "At Countryside in Moore, OK, choose from spacious one and two-bedroom floor plans designed for comfort and style. Experience a vibrant community atmosphere where neighbors become friends. Curious about life here? Schedule a tour today and see what our residents love most about calling Countryside home!",
  "property_thankyou_blurb": "Thank you for reaching out to Countryside in Moore, OK! Our vibrant community offers thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. A member of our team will connect with you soon to help you find your perfect home. Get ready to embrace your new beginning!",
  "property_virtualtours_blurb": "Experience the charm of Countryside in Moore, OK, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom floor plans, each offering a unique blend of modern amenities and tranquility. Step inside and let our virtual tour guide you through your future home today!",
  "property_copyright": "2026 All Rights Reserved. Countryside",
  "property_seo_title_home": "Countryside |  Apartments in Moore, OK",
  "property_seo_description_home": "Experience modern living at Countryside in Moore, OK. From stylish one and two-bedroom apartments to resort-style amenities, your perfect home awaits.",
  "property_seo_title_floorplans": "Floor Plans | Moore, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Countryside in Moore, OK! With stylish one and two-bedroom floor plans, your perfect home awaits. Browse today!",
  "property_seo_title_amenities": "Amenities | Moore, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Countryside in Moore, OK! Enjoy spacious layouts, on-site amenities, and a welcoming community. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Moore, OK",
  "property_seo_description_gallery": "Dreaming of a new home? Countryside in Moore, OK offers spacious, stylish apartments with top-notch amenities. Picture your perfect life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Countryside Apartments",
  "property_seo_description_virtualtours": "Step inside Countryside in Moore, OK! Experience our one and two-bedroom apartments through a captivating virtual tour. Your dream home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Countryside Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Countryside in Moore, OK! Explore our interactive map for floor plans, pricing, and amenities like a pool and fitness center.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Moore, OK",
  "property_seo_description_neighborhood": "Explore vibrant local favorites and charming hotspots just steps from your door in Moore, OK, at Countryside! Discover your new neighborhood!",
  "property_seo_title_contact": "Contact Us | Countryside",
  "property_seo_description_contact": "Reach out to Countryside in Moore, OK! Whether you're interested in one or two-bedroom layouts, our leasing team is ready to help with your queries today!",
  "property_seo_title_faqs": "FAQs | Apartments in Moore, OK",
  "property_seo_description_faqs": "Find answers to your questions about Countryside in Moore, OK! From amenities to lease options, our FAQs guide you to your perfect home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Moore, OK",
  "property_seo_description_reviews": "Join the vibrant community at Countryside in Moore, OK! Read resident reviews and discover a lifestyle filled with amenities, comfort, and convenience.",
  "property_seo_title_applynow": "Apply Now | Apartments in Moore, OK",
  "property_seo_description_applynow": "Discover your haven at Countryside, Moore, OK! Enjoy spacious layouts, luxury amenities, and a friendly community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Countryside",
  "property_seo_description_residentaccess": "Log in to your Countryside resident portal in Moore, OK, to effortlessly manage rent, request maintenance, and connect with your community—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Countryside",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Countryside in Moore, OK, and help them find their perfect home in our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Countryside",
  "property_seo_description_scheduletour": "Experience the charm of Countryside in Moore, OK. Schedule your tour today and see why our community feels like home. Your oasis awaits!",
  "property_seo_title_privacy": "Privacy Policy | Countryside",
  "property_seo_description_privacy": "At Countryside in Moore, OK, your privacy is our priority. Learn how we protect your data while you enjoy a community that feels like home. View our policy!",
  "property_seo_title_accessibility": "Website Accessibility | Countryside",
  "property_seo_description_accessibility": "At Countryside in Moore, OK, we embrace digital inclusion. Our commitment ensures accessible living for everyone. Join us in fostering an inviting community!",
  "property_seo_title_sitemap": "Sitemap | Countryside",
  "property_seo_description_sitemap": "Navigate Countryside in Moore, OK, effortlessly! Check out our sitemap to find your perfect home and discover all the amenities we offer.",
  "property_seo_title_thankyou": "Thank You | Countryside",
  "property_seo_description_thankyou": "Thank you for reaching out to Countryside in Moore, OK! A team member will connect with you soon to discuss your future home. We can’t wait to chat!",
  "property_seo_title_pets": "Pet Policy | Apartments in Moore, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293655607",
  "amenities": [
    {
      "id": "ec_2c1f0ef4f09b389ebdf5ca24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "119112257",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d9a43-3792-763c-a697-2f074e90c8fd.webp",
      "amenity_image_media": {
        "alt_text": "Lobby with comfortable seating, decorative fireplace, and TV.",
        "public_id": "019d9a43-3792-763c-a697-2f074e90c8fd",
        "storage_key": "property/6767906449167073/019d9a43-3792-763c-a697-2f074e90c8fd.webp",
        "width": 3072,
        "height": 2049
      },
      "amenity_image_alt_text": "the lobby at the bradley braddock road station apartments",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d7cd042204ab0af12c103b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89427486",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d9a43-25db-76aa-acd1-b55f90b40a3d.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas outside apartment buildings.",
        "public_id": "019d9a43-25db-76aa-acd1-b55f90b40a3d",
        "storage_key": "property/6767906449167073/019d9a43-25db-76aa-acd1-b55f90b40a3d.webp",
        "width": 640,
        "height": 480
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4600970bb6bcf034a88d2c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89427489",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-2c90-72f6-a406-36d34d3ed25d.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, free weights, and exercise balls.",
        "public_id": "019d01af-2c90-72f6-a406-36d34d3ed25d",
        "storage_key": "property/6767906449167073/019d01af-2c90-72f6-a406-36d34d3ed25d.webp",
        "width": 3072,
        "height": 2047
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_368800f2da03de208917f7f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89572690",
      "title": "24-Hour Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d9a43-2535-7614-91b0-35f18ec5474e.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and seating",
        "public_id": "019d9a43-2535-7614-91b0-35f18ec5474e",
        "storage_key": "property/6767906449167073/019d9a43-2535-7614-91b0-35f18ec5474e.webp",
        "width": 1000,
        "height": 749
      },
      "amenity_image_alt_text": "Villas at Countryside Business Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcb44e7a1e699d94137671f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89427483",
      "title": "Community Gas Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-b863-72ed-bc8a-47ea823b16ff.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor grilling area with two stainless steel grills, stone countertops, and apartment buildings in the background.",
        "public_id": "019d01af-b863-72ed-bc8a-47ea823b16ff",
        "storage_key": "property/6767906449167073/019d01af-b863-72ed-bc8a-47ea823b16ff.webp",
        "width": 640,
        "height": 480
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_756c49fdb42a06ddb3b09c7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89427485",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-b707-7706-a060-a0b261e50082.webp",
      "amenity_image_media": {
        "alt_text": "Dog park with agility equipment and seating",
        "public_id": "019d01af-b707-7706-a060-a0b261e50082",
        "storage_key": "property/6767906449167073/019d01af-b707-7706-a060-a0b261e50082.webp",
        "width": 640,
        "height": 480
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2aa110a1e83a9ed8116ab024",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89587562",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-be94-75cf-bf1a-eebac3caa760.webp",
      "amenity_image_media": {
        "alt_text": "Coffee and beverage station with a cold brew dispenser and condiments.",
        "public_id": "019d01af-be94-75cf-bf1a-eebac3caa760",
        "storage_key": "property/6767906449167073/019d01af-be94-75cf-bf1a-eebac3caa760.webp",
        "width": 3072,
        "height": 2047
      },
      "amenity_image_alt_text": "a coffee machine and a grill in the corner of a room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec4d46840d580590c8f09a3f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89427487",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_558327420da5bf9894882b55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89664231",
      "title": "Picnic Areas with Charcoal Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fd5b3ca99e9ceaec8231981",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "124799820",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9eb21024465fb501f5aff453",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "126783705",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ec83323416db01783d96889",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "120951100",
      "title": "Furnished Homes through CORT*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1cd5cd80300b3360cfd52e0b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89548306",
      "title": "In-Home Washer and Dryer*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d9a43-44d8-704d-bd00-02ff8e1650a7.webp",
      "amenity_image_media": {
        "alt_text": "In-unit washer and dryer with Tide detergent and abstract art.",
        "public_id": "019d9a43-44d8-704d-bd00-02ff8e1650a7",
        "storage_key": "property/6767906449167073/019d9a43-44d8-704d-bd00-02ff8e1650a7.webp",
        "width": 3072,
        "height": 2037
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71ac8834957ad47e77645e50",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "90927622",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d9a43-2f10-7558-8a29-cfff5697fd45.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room with abstract art and view of kitchen and bathroom.",
        "public_id": "019d9a43-2f10-7558-8a29-cfff5697fd45",
        "storage_key": "property/6767906449167073/019d9a43-2f10-7558-8a29-cfff5697fd45.webp",
        "width": 1200,
        "height": 675
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48217cc8067bc87ce11e2309",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "90927621",
      "title": "Storage Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4504523095653cfc0a2f01d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89587573",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-4c20-74ec-91fb-5c677c636bba.webp",
      "amenity_image_media": {
        "alt_text": "Living room and dining area with a fireplace and a view into the bedroom.",
        "public_id": "019d01af-4c20-74ec-91fb-5c677c636bba",
        "storage_key": "property/6767906449167073/019d01af-4c20-74ec-91fb-5c677c636bba.webp",
        "width": 3072,
        "height": 2033
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dce0171abac1fcc1e9bd4b44",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89587572",
      "title": "Walk-In Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-38b0-73ab-83e4-d3ea22261298.webp",
      "amenity_image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and a basket.",
        "public_id": "019d01af-38b0-73ab-83e4-d3ea22261298",
        "storage_key": "property/6767906449167073/019d01af-38b0-73ab-83e4-d3ea22261298.webp",
        "width": 3072,
        "height": 2036
      },
      "amenity_image_alt_text": "Villas at Countryside Walk-In Closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bfd603d7328201728d2fb5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "90927620",
      "title": "Private Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-c33e-755c-93cc-d88a30fdec29.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of an apartment building entrance with a covered walkway and parking lot in the background.",
        "public_id": "019d01af-c33e-755c-93cc-d88a30fdec29",
        "storage_key": "property/6767906449167073/019d01af-c33e-755c-93cc-d88a30fdec29.webp",
        "width": 1200,
        "height": 675
      },
      "amenity_image_alt_text": ",",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b851418190f4e252513f95cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89548309",
      "title": "Open Concept",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a9988a51132aa8000ce3a18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89548348",
      "title": "Spacious Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3d0497d5e91cc0bc9ec319d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89664246",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56812f8e9942789d2e9c5889",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "89664250",
      "title": "Spacious Kitchen with Ample Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14e4b0504a0493169231878b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "90927619",
      "title": "Farmhouse Style Kitchen Sink*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1935768613d22050ae99e6e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "90927624",
      "title": "Updated Lighting*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09415db4d84f7a4aa3114fd2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "yardi",
      "external_id": "110014854",
      "title": "*Preinstalled WiFi with 1st Month free from Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5895ce78962e13f1dba9b032",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-21d9-73ac-82ac-8d2dc4ca8b6b.webp",
      "image_media": {
        "alt_text": "Spacious living room and dining area with a sectional sofa and a small dining table.",
        "public_id": "019d01af-21d9-73ac-82ac-8d2dc4ca8b6b",
        "storage_key": "property/6767906449167073/019d01af-21d9-73ac-82ac-8d2dc4ca8b6b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living and dining area, perfect for entertaining or relaxing after a long day. This space features a comfortable sectional sofa and a chic dining set.",
      "link": "false",
      "alt_text": "Spacious living room and dining area with a sectional sofa and a small dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (1).jpg"
    },
    {
      "id": "ec_f31d2f605dfe8d404e67b3de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-212c-7474-9f8e-6f0f2d008e77.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019d01af-212c-7474-9f8e-6f0f2d008e77",
        "storage_key": "property/6767906449167073/019d01af-212c-7474-9f8e-6f0f2d008e77.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Beautifully renovated kitchen featuring stainless steel appliances, ample cabinet space, and a sleek countertop. Perfect for home chefs!",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (2).jpg"
    },
    {
      "id": "ec_cf5c58cfb36325de9a3e4051",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-1f9f-769c-b52a-b40a4c964c4f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and a view into the bathroom.",
        "public_id": "019d01af-1f9f-769c-b52a-b40a4c964c4f",
        "storage_key": "property/6767906449167073/019d01af-1f9f-769c-b52a-b40a4c964c4f.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, plush bedding, and a private en-suite bathroom with modern fixtures.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed and a view into the bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (3).jpg"
    },
    {
      "id": "ec_d8c758cca06c6761280c6e67",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-2b22-7669-985d-ce9c45efd3dc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, shower, and washer/dryer hookups.",
        "public_id": "019d01af-2b22-7669-985d-ce9c45efd3dc",
        "storage_key": "property/6767906449167073/019d01af-2b22-7669-985d-ce9c45efd3dc.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "A clean and spacious bathroom featuring a double vanity, shower with a stylish curtain, and in-unit laundry facilities.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, shower, and washer/dryer hookups.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (4).jpg"
    },
    {
      "id": "ec_48ac4a18202be4586f323be9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-38b0-73ab-83e4-d3ea22261298.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and a basket.",
        "public_id": "019d01af-38b0-73ab-83e4-d3ea22261298",
        "storage_key": "property/6767906449167073/019d01af-38b0-73ab-83e4-d3ea22261298.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and a decorative basket, perfect for organizing your belongings.",
      "link": "false",
      "alt_text": "Empty walk-in closet with wire shelving and a basket.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (5).jpg"
    },
    {
      "id": "ec_b2f120a376f9bfe191abfe95",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-2c90-72f6-a406-36d34d3ed25d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, free weights, and exercise balls.",
        "public_id": "019d01af-2c90-72f6-a406-36d34d3ed25d",
        "storage_key": "property/6767906449167073/019d01af-2c90-72f6-a406-36d34d3ed25d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, strength training equipment, and free weights.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, weight machines, free weights, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (13).jpg"
    },
    {
      "id": "ec_d5fd4ae1d8903c246a36c561",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-2e88-778b-acf5-98a828412788.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019d01af-2e88-778b-acf5-98a828412788",
        "storage_key": "property/6767906449167073/019d01af-2e88-778b-acf5-98a828412788.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, ample cabinet space, and a view into the living area.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (14).jpg"
    },
    {
      "id": "ec_bec19b3b166e76505eb5225f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-36fe-76ec-adf1-56caf52d9ec0.webp",
      "image_media": {
        "alt_text": "Bedroom with open closet and view of laundry area",
        "public_id": "019d01af-36fe-76ec-adf1-56caf52d9ec0",
        "storage_key": "property/6767906449167073/019d01af-36fe-76ec-adf1-56caf52d9ec0.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet and convenient access to an in-unit laundry area.",
      "link": "false",
      "alt_text": "Bedroom with open closet and view of laundry area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (15).jpg"
    },
    {
      "id": "ec_a3451efdd21d554261f31713",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-4c20-74ec-91fb-5c677c636bba.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a fireplace and a view into the bedroom.",
        "public_id": "019d01af-4c20-74ec-91fb-5c677c636bba",
        "storage_key": "property/6767906449167073/019d01af-4c20-74ec-91fb-5c677c636bba.webp",
        "width": 3072,
        "height": 2033
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a fireplace and a view into the bedroom. This open-concept layout is perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Living room and dining area with a fireplace and a view into the bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (16).jpg"
    },
    {
      "id": "ec_847cb0c48285dbd6fff5e3f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-45a4-73d3-9a06-c1e0757a590f.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, dumbbells, and weight machines.",
        "public_id": "019d01af-45a4-73d3-9a06-c1e0757a590f",
        "storage_key": "property/6767906449167073/019d01af-45a4-73d3-9a06-c1e0757a590f.webp",
        "width": 3072,
        "height": 2035
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and weight machines for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, dumbbells, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (17).jpg"
    },
    {
      "id": "ec_b098869e0678560f1d66a982",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-2c90-72f6-a406-36d34d3ed25d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, free weights, and exercise balls.",
        "public_id": "019d01af-2c90-72f6-a406-36d34d3ed25d",
        "storage_key": "property/6767906449167073/019d01af-2c90-72f6-a406-36d34d3ed25d.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, strength training equipment, and free weights.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, weight machines, free weights, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (18).jpg"
    },
    {
      "id": "ec_1b98a72088c805f403cfdcc9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-5b16-7576-b3d7-6ae1cec5d9ff.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and an outdoor kitchen area at a multifamily property.",
        "public_id": "019d01af-5b16-7576-b3d7-6ae1cec5d9ff",
        "storage_key": "property/6767906449167073/019d01af-5b16-7576-b3d7-6ae1cec5d9ff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool and outdoor kitchen area, perfect for relaxing and entertaining guests.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and an outdoor kitchen area at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (20).jpg"
    },
    {
      "id": "ec_48bf16dc3ce8448dfa0e9d6d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-6434-7339-957e-e72dc09ef0d2.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two built-in stainless steel grills and granite countertops under a wooden pergola.",
        "public_id": "019d01af-6434-7339-957e-e72dc09ef0d2",
        "storage_key": "property/6767906449167073/019d01af-6434-7339-957e-e72dc09ef0d2.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and entertaining at our outdoor kitchen, complete with built-in grills and comfortable seating areas.",
      "link": "false",
      "alt_text": "Outdoor grilling station with two built-in stainless steel grills and granite countertops under a wooden pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (21).jpg"
    },
    {
      "id": "ec_a022a962644adcdef71bfb14",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-38b0-73ab-83e4-d3ea22261298.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and a basket.",
        "public_id": "019d01af-38b0-73ab-83e4-d3ea22261298",
        "storage_key": "property/6767906449167073/019d01af-38b0-73ab-83e4-d3ea22261298.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and a decorative basket, perfect for organizing your belongings.",
      "link": "false",
      "alt_text": "Empty walk-in closet with wire shelving and a basket.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (22).jpg"
    },
    {
      "id": "ec_fa928b730f9486f1a108d3e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-7539-75c2-b813-014c71dc0bd1.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building entrance with blue siding and red brick accents.",
        "public_id": "019d01af-7539-75c2-b813-014c71dc0bd1",
        "storage_key": "property/6767906449167073/019d01af-7539-75c2-b813-014c71dc0bd1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "View of the exterior of a multifamily property, showcasing the building entrance with blue siding and brick details, surrounded by lush landscaping.",
      "link": "false",
      "alt_text": "Exterior view of an apartment building entrance with blue siding and red brick accents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (23).jpg"
    },
    {
      "id": "ec_d3948da3d6590b55599dae9c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-8962-72ca-90d1-e1b71c940aef.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and flower beds.",
        "public_id": "019d01af-8962-72ca-90d1-e1b71c940aef",
        "storage_key": "property/6767906449167073/019d01af-8962-72ca-90d1-e1b71c940aef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds featuring apartment buildings with well-maintained lawns and vibrant flower gardens, creating an inviting community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and flower beds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (24).jpg"
    },
    {
      "id": "ec_f8e71cb427113345c2ef1699",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-8975-72df-8bbc-af89ab2c0ca6.webp",
      "image_media": {
        "alt_text": "Exterior view of a light blue apartment building with balconies and green lawn.",
        "public_id": "019d01af-8975-72df-8bbc-af89ab2c0ca6",
        "storage_key": "property/6767906449167073/019d01af-8975-72df-8bbc-af89ab2c0ca6.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Community",
      "description": "Exterior view of a light blue apartment building featuring multiple balconies, well-maintained green spaces, and a paved walkway.",
      "link": "false",
      "alt_text": "Exterior view of a light blue apartment building with balconies and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (25).jpg"
    },
    {
      "id": "ec_5616e3e5d6086bec4dabebc5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-91b7-723d-b808-7177814e5cd4.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with well-maintained grounds and landscaping.",
        "public_id": "019d01af-91b7-723d-b808-7177814e5cd4",
        "storage_key": "property/6767906449167073/019d01af-91b7-723d-b808-7177814e5cd4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious apartment complex featuring multiple buildings with lush green courtyards and ample parking. Enjoy a vibrant community atmosphere.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with well-maintained grounds and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (26).jpg"
    },
    {
      "id": "ec_2aff3929918fa499732560be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01af-914f-777e-baf1-71bb7e72e792.webp",
      "image_media": {
        "alt_text": "The Villas at Countryside monument sign and apartment buildings.",
        "public_id": "019d01af-914f-777e-baf1-71bb7e72e792",
        "storage_key": "property/6767906449167073/019d01af-914f-777e-baf1-71bb7e72e792.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Community",
      "description": "Welcome to The Villas at Countryside, offering luxury apartments in a beautiful community setting. Enjoy our well-maintained grounds and elegant architecture.",
      "link": "false",
      "alt_text": "The Villas at Countryside monument sign and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (27).jpg"
    },
    {
      "id": "ec_728409d54c852fd5a827d738",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d146e-aadd-71f8-8534-88d398ed20a2.webp",
      "image_media": {
        "alt_text": "The Villas at Countryside leasing center entrance with manicured landscaping.",
        "public_id": "019d146e-aadd-71f8-8534-88d398ed20a2",
        "storage_key": "property/6767906449167073/019d146e-aadd-71f8-8534-88d398ed20a2.webp",
        "width": 3072,
        "height": 2036
      },
      "title": "Community",
      "description": "Welcome to The Villas at Countryside, where you can find your new home. Visit our leasing center today.",
      "link": "false",
      "alt_text": "The Villas at Countryside leasing center entrance with manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Villas_at_Countryside_Favorites (28).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_8061dea3-be64-4cc8-86a3-7f8b6e45a930",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1109 E Interstate 240 Service Rd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, prime rib, and rolls with cinnamon butter. They also highlight the fast service, friendly staff, and fun atmosphere.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-92f2-727b-afa8-111583687ec7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-92f2-727b-afa8-111583687ec7",
        "storage_key": "property/6767906449167073/019d01b0-92f2-727b-afa8-111583687ec7.webp",
        "width": 1188,
        "height": 1280
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-south-i-240?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=13128196108413720888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.3922",
      "poi_longitude": "-97.4918158",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-631-8392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a16-7728-8469-6fc59c318cdf",
        "storage_key": "property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_b1ObMVsocROFmq7824MLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_5df4b489-ae0d-41a2-9940-1faf7ad4af5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Taste of China Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7435 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Relaxed dining space offering all-you-can-eat buffets of sushi, Chinese & Mexican food & desserts.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food, including Chinese, Mexican, and American options, as well as a Mongolian grill and sushi bar. They also highlight the family-friendly atmosphere and the attentive service.\n\nSome reviews mention the food quality can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-92ed-7613-8ae2-ab2365600cf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-92ed-7613-8ae2-ab2365600cf0",
        "storage_key": "property/6767906449167073/019d01b0-92ed-7613-8ae2-ab2365600cf0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tasteofchinarestaurant.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5294159430709800755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taste-of-china-restaurant",
      "poi_latitude": "35.3922925",
      "poi_longitude": "-97.5309638",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-631-1688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a16-7728-8469-6fc59c318cdf",
        "storage_key": "property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXuPCIwTsocRM--92_OheEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_a3f94104-6a33-48c0-bdce-af02ab0a90ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "920 W I-240 Service Road, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious sandwiches and a tasty breakfast menu. They also highlight the fast service, friendly staff, and efficient drive-thru.\n\nOther reviews mention the drinks can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-9312-701d-8ace-36150c9fd22c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-9312-701d-8ace-36150c9fd22c",
        "storage_key": "property/6767906449167073/019d01b0-9312-701d-8ace-36150c9fd22c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/240-western?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=18248885707953318924&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.3905415",
      "poi_longitude": "-97.5313285",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-632-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a16-7728-8469-6fc59c318cdf",
        "storage_key": "property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPb_qvI4TsocRDKxCWd0QQf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_742eb592-fc19-4a74-bc64-d1d5cc34f148",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1613 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and Texas toast. They also highlight the fast service and friendly staff.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-9305-757e-8296-46935ca1c9d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-9305-757e-8296-46935ca1c9d9",
        "storage_key": "property/6767906449167073/019d01b0-9305-757e-8296-46935ca1c9d9.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/oklahoma-city/1613-w-i-240-service-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=14573184076024911847&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "35.3920295",
      "poi_longitude": "-97.5458791",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-680-9103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a16-7728-8469-6fc59c318cdf",
        "storage_key": "property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8jxypUTsocR5xfYgbRZPso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_f2da8da4-15a5-45a8-8e50-a5e4f0b9c831",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Pier 88 Boiling Seafood & Bar OKC",
      "poi_type": "Restaurants",
      "poi_address": "2125 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Easygoing, seafood-focused chain serving boils, plus oysters, fried eats and cocktails.",
      "poi_long_description": "People say this seafood restaurant serves delicious catfish, boils, and wings with various heat levels. They also highlight the excellent happy hour times and the good value.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-97b4-724d-a248-87073fbcd7b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-97b4-724d-a248-87073fbcd7b7",
        "storage_key": "property/6767906449167073/019d01b0-97b4-724d-a248-87073fbcd7b7.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://direct.chownow.com/order/11293/locations/15613?cn_channel=cn_google&utm_source=cn_google&deliversToMe=1&rwg_token=ACgRB3f0f7XIIWpClGqQlLu0NvSZLIU7ure3hVF2pjf63wsZfppL88b0Bfz1vqfS0nD75QSXuIvUfHPUGL8CAM-vNxKNbX_QCg%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16035403566497813150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pier-88-boiling-seafood--bar-okc",
      "poi_latitude": "35.3920738",
      "poi_longitude": "-97.5492838",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-601-8812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a16-7728-8469-6fc59c318cdf",
        "storage_key": "property/6767906449167073/019d01b0-5a16-7728-8469-6fc59c318cdf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtW4L974TsocRnlIio5Uyid4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_99e6b022-becf-4866-927a-83b69a5df2e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "World Fresh International Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10700 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Produce and meat purveyor for Asian ingredients, baked goods and ethnic eats, plus tea.",
      "poi_long_description": "People say this grocery store offers a wide variety of international foods, including noodles, rice, fresh produce, and a selection of cookware. They also highlight the clean and organized layout, and the presence of a bakery, restaurants, and a cafe with boba.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-97b4-724d-a248-82caa43e5a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-97b4-724d-a248-82caa43e5a6d",
        "storage_key": "property/6767906449167073/019d01b0-97b4-724d-a248-82caa43e5a6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.worldfreshmarketokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15266477169668212953&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "world-fresh-international-market",
      "poi_latitude": "35.3612615",
      "poi_longitude": "-97.5467944",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-349-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a18-70de-9a72-4148eaed4c3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a18-70de-9a72-4148eaed4c3b",
        "storage_key": "property/6767906449167073/019d01b0-5a18-70de-9a72-4148eaed4c3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnVfSKFoTsocR2UivvRls3dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d98b54af-af37-431e-99d2-cb7524a04f7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12100 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce, delicious breads, and high-quality meats. They highlight the store is clean, well-organized, and stocks items not found elsewhere, including gluten-free and vegan options. They also like the friendly, helpful, and informative staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-97d8-7317-9de9-c99e07b52faf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-97d8-7317-9de9-c99e07b52faf",
        "storage_key": "property/6767906449167073/019d01b0-97d8-7317-9de9-c99e07b52faf.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.sprouts.com/store/ok/moore/moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=463326420679037265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.3469891",
      "poi_longitude": "-97.5466047",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-416-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a18-70de-9a72-4148eaed4c3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a18-70de-9a72-4148eaed4c3b",
        "storage_key": "property/6767906449167073/019d01b0-5a18-70de-9a72-4148eaed4c3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9YBcOkTsocRUZGgv-wQbgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9983928d-e68e-4789-9156-1f4039b7e30e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10601 S May Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Chain grocery outlet supplying produce, baked goods, and sushi, plus self-checkout.",
      "poi_long_description": "People say this grocery store offers fresh meat and produce, and a wide selection of items, including specialty items and a large candy wall. They highlight the good prices, sales, and the clean, organized, and spacious layout. They also like the friendly, helpful, and courteous staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-988e-746d-ad3e-42028b6b320b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-988e-746d-ad3e-42028b6b320b",
        "storage_key": "property/6767906449167073/019d01b0-988e-746d-ad3e-42028b6b320b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4018949886565178595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.3622151",
      "poi_longitude": "-97.5680332",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-814-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a18-70de-9a72-4148eaed4c3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a18-70de-9a72-4148eaed4c3b",
        "storage_key": "property/6767906449167073/019d01b0-5a18-70de-9a72-4148eaed4c3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwfJhuAITsocR41zQ5qAtxjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c813a653-99e7-43fc-8006-15709bc0c656",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7400 S Shields Blvd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store is well-stocked and the staff are helpful, friendly, and eager to guide customers to the products they need. They also highlight the great customer service and good deals and promotions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-47ea-768c-bde5-6339be874b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-47ea-768c-bde5-6339be874b2b",
        "storage_key": "property/6767906449167073/019d01b0-47ea-768c-bde5-6339be874b2b.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/S-Oklahoma-City/OK/Oklahoma-City/73149/3901?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9319995899506957809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.3933171",
      "poi_longitude": "-97.5048175",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-631-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a1c-71ae-b453-2c251148d1dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a1c-71ae-b453-2c251148d1dd",
        "storage_key": "property/6767906449167073/019d01b0-5a1c-71ae-b453-2c251148d1dd.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZZnC3msUsocR8Z01IuRGV4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f3d8b035-358e-40af-96e6-9e442196731e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "755 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of bulk foods, including spices, candy, and granola, as well as fresh produce and a good selection of meat. They highlight the affordable prices, especially on bulk items, and the clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-9d51-726e-954a-7125043de165.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-9d51-726e-954a-7125043de165",
        "storage_key": "property/6767906449167073/019d01b0-9d51-726e-954a-7125043de165.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16116728468117303121&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.3211875",
      "poi_longitude": "-97.501428",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-759-6329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5a18-70de-9a72-4148eaed4c3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5a18-70de-9a72-4148eaed4c3b",
        "storage_key": "property/6767906449167073/019d01b0-5a18-70de-9a72-4148eaed4c3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQsfeThrsocRUa-O0yYfqt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_787630e7-7cba-460a-a30e-1805056d6451",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Oklahoma City Community College",
      "poi_type": "Education",
      "poi_address": "7777 S May Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-2161-732e-ab34-30bcc4fdf6cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-2161-732e-ab34-30bcc4fdf6cb",
        "storage_key": "property/6767906449167073/019d01b0-2161-732e-ab34-30bcc4fdf6cb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.occc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12663331797127596950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-community-college",
      "poi_latitude": "35.3880406",
      "poi_longitude": "-97.5699184",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-682-1611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5dbe-738e-9ae6-155f4b2161ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5dbe-738e-9ae6-155f4b2161ce",
        "storage_key": "property/6767906449167073/019d01b0-5dbe-738e-9ae6-155f4b2161ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq1zRlkwSsocRlguzIC0xva8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9ff05b47-bff8-4ce2-9c07-46407c92f395",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Mid-America Christian University",
      "poi_type": "Education",
      "poi_address": "3500 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-9d48-7549-9610-5dae2a90a600.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-9d48-7549-9610-5dae2a90a600",
        "storage_key": "property/6767906449167073/019d01b0-9d48-7549-9610-5dae2a90a600.webp",
        "width": 1280,
        "height": 453
      },
      "poi_business_url": "https://www.macu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1537180270262459685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mid-america-christian-university",
      "poi_latitude": "35.3477803",
      "poi_longitude": "-97.5784864",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-691-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5dbe-738e-9ae6-155f4b2161ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5dbe-738e-9ae6-155f4b2161ce",
        "storage_key": "property/6767906449167073/019d01b0-5dbe-738e-9ae6-155f4b2161ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIw1jLcMSsocRJZ27vE8pVRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c6292518-30cf-4ecf-b006-25582fc3292d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Pioneer Library System - Moore Public Library",
      "poi_type": "Education",
      "poi_address": "225 S Howard Ave, Moore, OK 73160, USA",
      "poi_short_description": "Local institution that provides books, DVDs, computers and programs, with an emphasis on children's offerings.",
      "poi_long_description": "People say this library offers a good selection of books and other materials, and has a large area for children to explore, play, and learn. They highlight the library hosts engaging weekly programs for kids and has a photo booth, and the staff are helpful and kind. They also like the clean and well-kept facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-9ec2-7027-9adf-09dde188000c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-9ec2-7027-9adf-09dde188000c",
        "storage_key": "property/6767906449167073/019d01b0-9ec2-7027-9adf-09dde188000c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pioneerlibrarysystem.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13566280005030728682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-library-system---moore-public-library",
      "poi_latitude": "35.3358205",
      "poi_longitude": "-97.4885841",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-793-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-65c4-7173-8d55-6013a56ec3c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-65c4-7173-8d55-6013a56ec3c5",
        "storage_key": "property/6767906449167073/019d01b0-65c4-7173-8d55-6013a56ec3c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xg3BdMUsocR6lNXj8kbRbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b132d48e-6d8a-42fb-bb09-ac6951bd5acd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Christian Heritage Academy",
      "poi_type": "Education",
      "poi_address": "4400 SE 27th St, Del City, OK 73115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-9ef2-7206-add5-5634d1ebfa9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-9ef2-7206-add5-5634d1ebfa9f",
        "storage_key": "property/6767906449167073/019d01b0-9ef2-7206-add5-5634d1ebfa9f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://cha.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10113757647911313450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christian-heritage-academy",
      "poi_latitude": "35.436904",
      "poi_longitude": "-97.4396806",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-672-1787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5dbe-738e-9ae6-155f4b2161ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5dbe-738e-9ae6-155f4b2161ce",
        "storage_key": "property/6767906449167073/019d01b0-5dbe-738e-9ae6-155f4b2161ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_wqRZR0WsocRKuAk7P5IW4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_01e9d7bc-1342-4369-a20e-17794f913d97",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Museum of Osteology",
      "poi_type": "Entertainment",
      "poi_address": "10301 S Sunnylane Rd, Oklahoma City, OK 73160, USA",
      "poi_short_description": "Unique spot for educational exhibits of 300+ skeletons of many species plus hands-on displays.",
      "poi_long_description": "Visitors say this museum offers a unique experience with a vast collection of skeletons, including animals, humans, and forensic exhibits. They also highlight the friendly and knowledgeable staff, educational value, and engaging scavenger hunts for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-a2b7-75b1-9a40-880e2196d987.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-a2b7-75b1-9a40-880e2196d987",
        "storage_key": "property/6767906449167073/019d01b0-a2b7-75b1-9a40-880e2196d987.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.skeletonmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9091622308725140297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-osteology",
      "poi_latitude": "35.3648349",
      "poi_longitude": "-97.4418414",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-814-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-615b-7019-aa2d-43040c2740b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-615b-7019-aa2d-43040c2740b0",
        "storage_key": "property/6767906449167073/019d01b0-615b-7019-aa2d-43040c2740b0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57ahxGMVsocRSSuU_1HuK34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_93a4abba-18bc-47c7-be21-96b66e129c18",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "First Americans Museum",
      "poi_type": "Entertainment",
      "poi_address": "659 First Americans Blvd, Oklahoma City, OK 73129, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this museum offers a wealth of information about the history and culture of Native Americans, with engaging exhibits including videos, artifacts, and oral histories. They also highlight the stunning architecture of the building and the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-a28f-7283-8475-5c70ef147d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-a28f-7283-8475-5c70ef147d5b",
        "storage_key": "property/6767906449167073/019d01b0-a28f-7283-8475-5c70ef147d5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.famok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1363703120278945108&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "first-americans-museum",
      "poi_latitude": "35.4580352",
      "poi_longitude": "-97.4820974",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-594-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-615b-7019-aa2d-43040c2740b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-615b-7019-aa2d-43040c2740b0",
        "storage_key": "property/6767906449167073/019d01b0-615b-7019-aa2d-43040c2740b0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4b90oEXsocRVH1RP8PY7BI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4566c2bd-9a07-412a-8896-523f983670b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "2800 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a wide variety of fun activities for kids and adults, including go-karts, bumper cars, virtual reality, ropes courses, and trampolines.\n\nOther reviews mention some attractions can be closed and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-2313-711f-81c0-56a7c9ad2951.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-2313-711f-81c0-56a7c9ad2951",
        "storage_key": "property/6767906449167073/019d01b0-2313-711f-81c0-56a7c9ad2951.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-moore/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=454199799262834417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.3130452",
      "poi_longitude": "-97.4932574",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-655-5805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcSyRgFtrsocR8W4dnE-kTQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_cc4876b7-510c-48f7-b780-3380c52e01b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "1615 Penn Park Blvd, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of slides, a dodgeball court, and a basketball area, providing fun for kids and adults. They highlight the clean and spacious facility, and the fast-moving lines. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-a45b-75ed-96be-6ab3beac06c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-a45b-75ed-96be-6ab3beac06c1",
        "storage_key": "property/6767906449167073/019d01b0-a45b-75ed-96be-6ab3beac06c1.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-south-okc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9469311704620469558&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "35.3932998",
      "poi_longitude": "-97.5461346",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-450-8018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8Bb3WgTsocRNg1aJdPAaYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_d1a41bcb-0014-44e9-aea9-fa069deb6e30",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "CB Speegle Stadium",
      "poi_type": "Entertainment",
      "poi_address": "698 SW Grand Blvd #600, Oklahoma City, OK 73109, USA",
      "poi_short_description": "High school sports arena with grandstands for football and soccer matches, clean restrooms and a concession stand.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-a646-72bc-b033-5b512f325125.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-a646-72bc-b033-5b512f325125",
        "storage_key": "property/6767906449167073/019d01b0-a646-72bc-b033-5b512f325125.webp",
        "width": 1240,
        "height": 826
      },
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2507",
      "poi_directions_map_url": "https://maps.google.com/?cid=15079213612661253080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cb-speegle-stadium",
      "poi_latitude": "35.4276518",
      "poi_longitude": "-97.5246653",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-c439-728b-8e94-ed879415a453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-c439-728b-8e94-ed879415a453",
        "storage_key": "property/6767906449167073/019d01b0-c439-728b-8e94-ed879415a453.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCYo7K60WsocR2KPoOuMgRNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_4bca0fd8-5ec5-4e5f-a397-d852a58f829d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Earlywine Park YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "11801 S May Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Vast gym & fitness center featuring an indoor swimming pool, a kids' play area, and a walking trail.",
      "poi_long_description": "People say this gym offers a wide variety of fitness equipment, classes, and amenities, including a pool, basketball courts, and a walking trail. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the community-focused atmosphere.\n\nOther reviews mention the basketball courts can be unavailable at certain times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-a7cb-761b-94fd-00e8d8670d9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-a7cb-761b-94fd-00e8d8670d9e",
        "storage_key": "property/6767906449167073/019d01b0-a7cb-761b-94fd-00e8d8670d9e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/earlywine-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3511656398763592292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "earlywine-park-ymca",
      "poi_latitude": "35.349746",
      "poi_longitude": "-97.566403",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-378-0420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv7zS1CETsocRZAqInePouzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_022866c7-9f6a-43d8-b608-70d1ff59e2d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4106 S Western Ave, Oklahoma City, OK 73109, USA",
      "poi_short_description": "Chain fitness center with an indoor pool, a basketball court, a sauna, and a variety of group fitness classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines, free weights, cardio, and a basketball court, as well as group fitness classes like HIIT, body pump, and yoga. They also highlight the reasonable prices, convenient hours, and the positive and motivating atmosphere.\n\nOther reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-a740-721d-87a6-ae76df5ef25b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-a740-721d-87a6-ae76df5ef25b",
        "storage_key": "property/6767906449167073/019d01b0-a740-721d-87a6-ae76df5ef25b.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ok/oklahoma-city/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=801655575634150052&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "35.4239616",
      "poi_longitude": "-97.5284652",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-992-0210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbC5qVYRsocRpILiqX8NIAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dabc7de6-9629-4153-bc5e-c98fc63aedff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Four Star Fitness - Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "1219 N Santa Fe Ave, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide range of equipment and workout options, including free weights, cardio machines, and a sauna. They highlight the positive and welcoming atmosphere, and the friendly and helpful staff. They also like the convenient 24/7 access and the availability of childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-aad2-7598-92cb-99f182f65c48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-aad2-7598-92cb-99f182f65c48",
        "storage_key": "property/6767906449167073/019d01b0-aad2-7598-92cb-99f182f65c48.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.fourstarfitnessokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11507987364897746889&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-star-fitness---moore",
      "poi_latitude": "35.348233",
      "poi_longitude": "-97.5138619",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-237-3740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4hkozQVsocRye9pVImVtJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3c0c87a4-ee00-4a7b-8d74-66ec880edeab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9118 S Western Ave A, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Bustling national chain gym with standard workout equipment, massage beds and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and a Black Card area with massage chairs and hydro massage. They highlight the clean, well-lit, and organized facility, and the comfortable, judgment-free atmosphere. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-a853-771a-8ffa-c1c75d2328e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-a853-771a-8ffa-c1c75d2328e7",
        "storage_key": "property/6767906449167073/019d01b0-a853-771a-8ffa-c1c75d2328e7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-brookwood-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7943029326332511845&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.3762027",
      "poi_longitude": "-97.5281104",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-237-3709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQsn6IETsocRZUaPnBZPO24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7fff582c-b050-4174-b718-3ce36d8bfb0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 SW 104th St, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Gym chain offering strength and cardio equipment, as well as tanning and saunas.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and cardio options, and provides classes. They highlight the affordable membership prices and the relaxing, friendly, and comfortable environment. They also like the helpful, supportive, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-ab99-72fe-812c-13c661ce1886.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-ab99-72fe-812c-13c661ce1886",
        "storage_key": "property/6767906449167073/019d01b0-ab99-72fe-812c-13c661ce1886.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://10gym.com/so-oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4025751960966699643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "35.3623584",
      "poi_longitude": "-97.5337511",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-691-0037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3Vq12QTsocRe5pAQxRY3jc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7ff6d479-7427-4f52-bfab-699c41caf146",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Animal Emergency & Surgical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "931 W I-240 Service Road, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-ad5c-764f-aa24-13b423fe8586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-ad5c-764f-aa24-13b423fe8586",
        "storage_key": "property/6767906449167073/019d01b0-ad5c-764f-aa24-13b423fe8586.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.okcanimalemergency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3482013980382145679&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency--surgical-center",
      "poi_latitude": "35.3919712",
      "poi_longitude": "-97.531539",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-631-7828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36JJPYwTsocRjyyfQ0SZUjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_09f1d4e9-6f9d-42cd-9358-31a6a52039c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Barbershop Fade Fathers",
      "poi_type": "Health and Wellness",
      "poi_address": "8013 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Barber shop in the 240 Plaza Shopping Center offering professional haircuts and beard trims.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-ada5-756c-87fe-ce1b70ebef26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-ada5-756c-87fe-ce1b70ebef26",
        "storage_key": "property/6767906449167073/019d01b0-ada5-756c-87fe-ce1b70ebef26.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fadefathers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12362820288136197204&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barbershop-fade-fathers",
      "poi_latitude": "35.3863046",
      "poi_longitude": "-97.5304614",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-764-3767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBy3H87MTsocRVLRZEI2Pkas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_8b885e25-2829-4411-89e9-94ec925c58bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "SpayXperts PLUS, Affordable Vet Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1065 SW 4th St, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-af14-7731-b860-22b37728a627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-af14-7731-b860-22b37728a627",
        "storage_key": "property/6767906449167073/019d01b0-af14-7731-b860-22b37728a627.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://spayxperts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7918936431623413321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spayxperts-plus-affordable-vet-care",
      "poi_latitude": "35.3347434",
      "poi_longitude": "-97.5117721",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-217-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE6FqorQUsocRSR7Qbbq25W0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ea9c2c8e-8ef1-4d12-b640-a2feccb4c64f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Victory Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "5721 Huettner Dr, Norman, OK 73069, USA",
      "poi_short_description": "Gymnastics center offering recreational classes, AAU and USAG competitive teams, and summer camps.",
      "poi_long_description": "People say this gymnastics center offers recreational classes, summer camps, and private lessons. They highlight the fun and engaging activities, and the positive impact on children's confidence and skills. They also like the kind, patient, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-b041-72d2-b29a-ac6d7b7abef7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-b041-72d2-b29a-ac6d7b7abef7",
        "storage_key": "property/6767906449167073/019d01b0-b041-72d2-b29a-ac6d7b7abef7.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "http://www.victorygymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16832765422714147590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "victory-gymnastics",
      "poi_latitude": "35.287754",
      "poi_longitude": "-97.483823",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-688-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-5dbe-738e-9ae6-155f4b2161ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-5dbe-738e-9ae6-155f4b2161ce",
        "storage_key": "property/6767906449167073/019d01b0-5dbe-738e-9ae6-155f4b2161ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxeHRVqprsocRBtNa2Pf-mek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_18b2d733-6fc8-44ff-bb84-57b397b811c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Oklahoma Heart Hospital South",
      "poi_type": "Health and Wellness",
      "poi_address": "5200 E Interstate 240 Service Rd, Oklahoma City, OK 73135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-b1b8-7118-89b6-b731c6cae7f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-b1b8-7118-89b6-b731c6cae7f4",
        "storage_key": "property/6767906449167073/019d01b0-b1b8-7118-89b6-b731c6cae7f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okheart.com/locations/oklahoma-heart-hospital-south",
      "poi_directions_map_url": "https://maps.google.com/?cid=10526556053115636738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-heart-hospital-south",
      "poi_latitude": "35.3895427",
      "poi_longitude": "-97.4267341",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-628-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-6159-7118-a0b5-255862f83434.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-6159-7118-a0b5-255862f83434",
        "storage_key": "property/6767906449167073/019d01b0-6159-7118-a0b5-255862f83434.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE67KjocVsocRAgwyTvXWFZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_acf9686f-cced-4be2-aa40-45b3ebdcaeee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "INTEGRIS Health Southwest Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 S Western Ave, Oklahoma City, OK 73109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-b246-7404-8d78-6cf0aed1c463.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-b246-7404-8d78-6cf0aed1c463",
        "storage_key": "property/6767906449167073/019d01b0-b246-7404-8d78-6cf0aed1c463.webp",
        "width": 683,
        "height": 384
      },
      "poi_business_url": "https://integrishealth.org/locations/hospital/integris-health-southwest-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12771302873382817443&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-southwest-medical-center",
      "poi_latitude": "35.4212648",
      "poi_longitude": "-97.5330065",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-636-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-6159-7118-a0b5-255862f83434.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-6159-7118-a0b5-255862f83434",
        "storage_key": "property/6767906449167073/019d01b0-6159-7118-a0b5-255862f83434.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28Mb51YRsocRo47oTkzIPLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_df04dc64-8db3-41f4-b0da-9c571349a252",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Scissortail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 SW 7th St, Oklahoma City, OK 73109, USA",
      "poi_short_description": "Lively space including gardens, a lake & playground, also home to a farmers' market & concerts.",
      "poi_long_description": "Visitors say this park offers a splash pad, playground, walking trails, and a farmers market, and they praise the beautiful gardens, clean facilities, and fun concerts. They also highlight the family-friendly atmosphere, plentiful free parking, and convenient location near the Paycom Center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-b360-72fb-b5e0-d05cdbb322dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-b360-72fb-b5e0-d05cdbb322dd",
        "storage_key": "property/6767906449167073/019d01b0-b360-72fb-b5e0-d05cdbb322dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://scissortailpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2532545101640635246&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scissortail-park",
      "poi_latitude": "35.4596348",
      "poi_longitude": "-97.5176865",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-445-6277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-64a9-76aa-add2-30e14290719e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-64a9-76aa-add2-30e14290719e",
        "storage_key": "property/6767906449167073/019d01b0-64a9-76aa-add2-30e14290719e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fS8K30XsocRbhPyGFpoJSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0f1146aa-b35a-42f1-9ced-9e7e0f26ff49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Buck Thomas Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1903 NE 12th St, Moore, OK 73160, USA",
      "poi_short_description": "Expansive, nearly 130-acre park featuring a playground, fishing, a walking trail & more.",
      "poi_long_description": "People say this park offers baseball fields, playgrounds, walking trails, and a dog park with separate areas for small and large dogs. They highlight the easy access, ample parking, and covered bleachers for spectators. They also like the family-friendly atmosphere and the availability of food trucks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-3b86-7409-a3f4-7eefd375c081.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-3b86-7409-a3f4-7eefd375c081",
        "storage_key": "property/6767906449167073/019d01b0-3b86-7409-a3f4-7eefd375c081.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/buck-thomas-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701592146103086508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buck-thomas-park",
      "poi_latitude": "35.3524633",
      "poi_longitude": "-97.4668896",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-64a9-76aa-add2-30e14290719e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-64a9-76aa-add2-30e14290719e",
        "storage_key": "property/6767906449167073/019d01b0-64a9-76aa-add2-30e14290719e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB31aBTwVsocRrK3BdXbVJb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3bdd3191-2404-4bcb-b0b6-401c1d96b1a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Little River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "709 SW 10th St, Moore, OK 73160, USA",
      "poi_short_description": "Family-friendly park with a splash park, a playground and a pirate ship.",
      "poi_long_description": "People say this park offers a fun splash pad with slides, a playground, and walking trails. They highlight the park is free, has plenty of shade and seating, and is great for kids of all ages. They also like that the splash pad is fenced and has a pirate theme.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-39cf-716c-b1b6-a3cb799266bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-39cf-716c-b1b6-a3cb799266bd",
        "storage_key": "property/6767906449167073/019d01b0-39cf-716c-b1b6-a3cb799266bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/little-river-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13309531068765424630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "little-river-park",
      "poi_latitude": "35.3275656",
      "poi_longitude": "-97.50192",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-64a9-76aa-add2-30e14290719e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-64a9-76aa-add2-30e14290719e",
        "storage_key": "property/6767906449167073/019d01b0-64a9-76aa-add2-30e14290719e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cPHdTZrsocR9svJeP3ztLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1769b41a-e6f8-49db-ad0c-8b992457bfc4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Earlywine Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11600 S Portland Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this golf course is challenging and well-maintained, with good greens and a new, state-of-the-art clubhouse. They also highlight the friendly and helpful staff, and the affordable prices.\n\nSome reviews mention the fairways can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-b736-769f-acd9-2485d2a1d66f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-b736-769f-acd9-2485d2a1d66f",
        "storage_key": "property/6767906449167073/019d01b0-b736-769f-acd9-2485d2a1d66f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okcgolf.com/earlywine-golf-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=12680274809197614446&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "earlywine-golf-course",
      "poi_latitude": "35.3519648",
      "poi_longitude": "-97.5817358",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-691-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-c585-7167-b1e6-b1fbb3ba08bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-c585-7167-b1e6-b1fbb3ba08bf",
        "storage_key": "property/6767906449167073/019d01b0-c585-7167-b1e6-b1fbb3ba08bf.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJj3nZU-4SsocRbtWOiMFi-a8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ff165ca7-29e3-4c33-8818-a66d5a64a81c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Trosper Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 SE 29th St, Oklahoma City, OK 73129, USA",
      "poi_short_description": "Heavily wooded 18-hole municipal golf course with a small creek plus instruction & practice greens.",
      "poi_long_description": "Heavily wooded 18-hole municipal golf course with a small creek plus instruction & practice greens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-b68d-777e-b756-ed6d1896c813.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-b68d-777e-b756-ed6d1896c813",
        "storage_key": "property/6767906449167073/019d01b0-b68d-777e-b756-ed6d1896c813.webp",
        "width": 720,
        "height": 481
      },
      "poi_business_url": "http://www.okcgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701287864837489120&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trosper-golf-course",
      "poi_latitude": "35.43541",
      "poi_longitude": "-97.471357",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-677-8874",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-c585-7167-b1e6-b1fbb3ba08bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-c585-7167-b1e6-b1fbb3ba08bf",
        "storage_key": "property/6767906449167073/019d01b0-c585-7167-b1e6-b1fbb3ba08bf.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJkacCD2UWsocR4EECdbjAJL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_2d601521-86b2-46d2-a0fc-7c6222c0b9eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Will Rogers International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7100 Terminal Dr, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Oklahoma City-area airport featuring art & an outdoor garden with a bronze statue of its namesake.",
      "poi_long_description": "People say this airport is small and easy to navigate, with clear signage and quick access to car rentals. They also highlight the clean restrooms, friendly staff, and efficient security process.\n\nOther reviews mention the food options can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-4463-74cc-a461-7638bdf5acc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-4463-74cc-a461-7638bdf5acc8",
        "storage_key": "property/6767906449167073/019d01b0-4463-74cc-a461-7638bdf5acc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flyokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14888269631623114364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "will-rogers-international-airport",
      "poi_latitude": "35.3888421",
      "poi_longitude": "-97.6001183",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-316-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-6588-7278-8b91-31e2a8c69ec3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-6588-7278-8b91-31e2a8c69ec3",
        "storage_key": "property/6767906449167073/019d01b0-6588-7278-8b91-31e2a8c69ec3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3X8qew0SsocRfK4hOVnCnc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9809bca5-7532-430d-b85c-277b77046e01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "EMSA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6205 S Sooner Rd, Oklahoma City, OK 73135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-b91d-7138-a3f4-f9e807a270a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-b91d-7138-a3f4-f9e807a270a9",
        "storage_key": "property/6767906449167073/019d01b0-b91d-7138-a3f4-f9e807a270a9.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://emsaok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11533109690373406475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emsa",
      "poi_latitude": "35.4034694",
      "poi_longitude": "-97.4247848",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-297-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VXjmk8_socRC39SiijWDaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_132d5b6e-0ead-4772-9d6f-6ebac04536f1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Balon Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3245 S Hattie Ave, Oklahoma City, OK 73129, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-ba0b-732e-9496-cc23e3d15a89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-ba0b-732e-9496-cc23e3d15a89",
        "storage_key": "property/6767906449167073/019d01b0-ba0b-732e-9496-cc23e3d15a89.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.balon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3475131748365701705&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "balon-corporation",
      "poi_latitude": "35.4316418",
      "poi_longitude": "-97.4884057",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-677-3321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQubgo8WsocRSRIFweklOjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6523c26d-e97f-409d-9f5b-9c9fd215d3bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "The Boeing Company BLDG 84-133",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6001 S Air Depot Blvd, Oklahoma City, OK 73135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10838506082843357847&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-boeing-company-bldg-84-133",
      "poi_latitude": "35.4048998",
      "poi_longitude": "-97.4073421",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-V5I2g-socRl_LJg9sbapY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a2f472ca-c234-4bd1-9bcc-53c8e2b16b94",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Simple Modern Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "750 SW 24th St Suite 300, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-ba9a-752c-aff8-8be7810c8893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-ba9a-752c-aff8-8be7810c8893",
        "storage_key": "property/6767906449167073/019d01b0-ba9a-752c-aff8-8be7810c8893.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "http://simplemodern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364504164759517206&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "simple-modern-headquarters",
      "poi_latitude": "35.3164404",
      "poi_longitude": "-97.5021957",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfe83ix9rsocRFjiYkB2Mcko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dcf771b6-f2be-4552-ade6-36ed275ab100",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Integrated Power Services (IPS) - Norman",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6707 N Interstate Dr, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-bc92-7719-a333-a57ee2772fc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01b0-bc92-7719-a333-a57ee2772fc4",
        "storage_key": "property/6767906449167073/019d01b0-bc92-7719-a333-a57ee2772fc4.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://ips.us/location/evans-norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2485684183795281028&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integrated-power-services-ips---norman",
      "poi_latitude": "35.2991008",
      "poi_longitude": "-97.4888055",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-631-1344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqenS6wRrsocRhKzsbpjsfiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_545b7e3a-7916-406a-b540-0a9f4025f299",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "poi_name": "Villas at Countryside",
      "poi_type": "Shopping & Retail",
      "poi_address": "9501 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say these apartments are spacious, clean, and well-maintained, with great amenities like a gym and pool. They also highlight the friendly, professional, and responsive staff and maintenance team.\n\nSome reviews mention the appliances can be faulty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019fc967-7c78-77ce-8c43-456a8f2faf17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc967-7c78-77ce-8c43-456a8f2faf17",
        "storage_key": "property/6767906449167073/019fc967-7c78-77ce-8c43-456a8f2faf17.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thevillasatcountryside.com/?rcstdid=Mg%3D%3D-YRjTEizZPgM%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1081632599764573911&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "villas-at-countryside",
      "poi_latitude": "35.3720301",
      "poi_longitude": "-97.4959286",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 405-759-5420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01b0-617a-772c-a694-af6ef2f7207d",
        "storage_key": "property/6767906449167073/019d01b0-617a-772c-a694-af6ef2f7207d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdZtHfQUsocR1x5zZh67Ag8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    }
  ],
  "office_hours": [
    {
      "id": "custom_dbe39b10-a9bf-49ec-8b08-d45455d10886",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_8d14b65d-62c0-42b7-a20f-f17c56877d70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_531b6d36-cd87-46a6-999d-ac30e63c0a76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "day": "WED",
      "open_time": "10:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_ac46bf06-590e-41f2-ad32-b0410b8b159a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_1c221d14-0175-457b-8402-ba6fd1dc0506",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_61a2d333-6a42-44bf-9acb-d54981ca9e31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_2e5cf267-435b-4674-85ee-fd3927f725d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "rating": "5.0",
      "name": "Charles Perrow",
      "text": "I’ve lived here for 5 months so far from June this year after moving here from MA.  They were incredibly helpful and tried to make sure I was as comfortable as possible after doing an emergency move across the country.  The apartments themselves are very pet friendly and even the single rooms are very spacious with in house laundry as well as valet trash.  The people that work in the office as well as all the maintenances staff are very nice an are wonderful to chat with",
      "date": "2025-11-06",
      "title": ""
    },
    {
      "id": "custom_12457cdf-bba2-4f79-9f79-28d5844df0a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "rating": "5.0",
      "name": "Justin Brown",
      "text": "I could not be more pleased with how accommodating the leasing office has been. Thank you so much to the staff, but especially Lexi, who has been helping me through this entire stressful process. Thank you so much for being so patient and understanding, as well as making sure I have all I needed to make this big move across the country less stressful!",
      "date": "2025-12-30",
      "title": ""
    },
    {
      "id": "custom_c65a20e4-6ee2-4208-b679-4cbde995682d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "rating": "5.0",
      "name": "Aerial",
      "text": "Darian with the maintenance team is truly outstanding! Every time we’ve needed help, he responds quickly, communicates clearly, and makes sure the job is done right the first time. His professionalism, attention to detail, and positive attitude makes a huge difference in our decision to live here. Thank you for handling that complicated request.",
      "date": "2025-11-21",
      "title": ""
    },
    {
      "id": "custom_68d354f5-da65-47e5-99a6-63c2f6dd30d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "rating": "5.0",
      "name": "Eliza Flores",
      "text": "After some very unpleasant experiences at other apartments, this place made it clear to me that it’s all about customer service. The ladies that helped me made me feel so comfortable and understood on what I was looking for. They were attentive to my requests and they never made me feel like I was just another person on a list taking up too much of their time. Thank you Dulce, Kaylee, and Lexie!",
      "date": "2025-11-06",
      "title": ""
    },
    {
      "id": "custom_71da945c-8297-47a6-b5dc-8eb34ac2c344",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "rating": "5.0",
      "name": "Elias Fleener",
      "text": "I have lived here for 4 months and I can confidently say that so far I love it. The main reason why I’m reviewing is because of how great my experience with maintenance has been. Every time I have had a problem they were quick to respond and were very polite. Today I put in a maintenance request for my refrigerator since it was not working and Darrian and Octavio were able to fix the problem before any of my food had a chance to defrost.",
      "date": "2025-11-14",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b79b07ea-64d9-4617-980a-08ee94ab8ba1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167073/019d01b1-6a55-7797-959e-8b5cec0712d0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with gray sofa, decorative chairs, ottoman, and kitchen pass-through with stools.",
        "public_id": "019d01b1-6a55-7797-959e-8b5cec0712d0",
        "storage_key": "property/6767906449167073/019d01b1-6a55-7797-959e-8b5cec0712d0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Villas At Countryside - 2BD Model (Renovated)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=uEik1YRHnTM"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e23be-9bda-7770-84ee-4f2a6c54a604",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Villas at Countryside Apartment Homes Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073"
    },
    {
      "lead_collector_id": "019e23be-9c5a-77bc-820d-5b938fdf3290",
      "lead_source": "LANDING_PAGE",
      "name": "Villas at Countryside Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-moore-ok",
      "search_query": "apartments with in-unit laundry Moore OK",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Moore, OK",
      "h2_subtitle": "Discover comfortable living with in-unit laundry options at Countryside. Enjoy modern amenities in a prime Moore, OK location.",
      "page_copy": "At Countryside, located in the welcoming embrace of South Oklahoma City, you'll find the appealing convenience of apartments with in-unit laundry. Experience the practicality of having a washer and dryer available in select units, perfect for those seeking modern comforts right at home.\n\nIn addition to in-unit laundry, Countryside offers an array of amenities that include a picnic area and grill for leisurely outdoor gatherings. Nestled in Cleveland County, our smoke-free community ensures a serene and clean living environment, enhanced by updated lighting throughout the property.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Moore, OK",
      "seo_description": "Discover apartments with in-unit laundry options at Countryside in Moore, OK. Enjoy a smoke-free community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-cleveland-county",
      "search_query": "air conditioned apartments Cleveland County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Cleveland County",
      "h2_subtitle": "Find your ideal air conditioned apartment at Countryside. Enjoy comfort and convenience in the heart of Cleveland County.",
      "page_copy": "Welcome to Countryside, where air conditioned apartments provide the comfort you deserve in beautiful Cleveland County. Located in the vibrant community of South Oklahoma City, our apartments are designed to offer residents optimal comfort and convenience.\n\nCountryside offers more than just comfortable temperatures; our community includes amenities such as a smoke-free environment, a picnic area complete with a grill, and updated lighting. Select units feature in-unit washer/dryers to enhance your living experience even further, creating an ideal home atmosphere in Moore, OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Cleveland County",
      "seo_description": "Explore air conditioned apartments at Countryside located in Cleveland County. Enjoy top amenities for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "apartments-with-pools-south-oklahoma-city",
      "search_query": "apartments with pools in South Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in South Oklahoma City",
      "h2_subtitle": "Explore Countryside's refreshing amenities in South Oklahoma City. Discover why our apartments with nearby pools are the ideal choice.",
      "page_copy": "While Countryside doesn't feature an on-site pool, it offers a wealth of amenities that make living in South Oklahoma City a delight. Situated in Cleveland County, Countryside ensures a comfortable and convenient lifestyle with smoke-free environments, a picnic area, and grilling facilities.\n\nResidents can enjoy updated lighting in their homes, and select units come with in-unit washer and dryers, enhancing your day-to-day convenience. Our apartment community is ideally located, providing easy access to nearby recreational facilities with pools, ensuring leisure and relaxation are always within reach.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools in South Oklahoma City",
      "seo_description": "Discover apartments with pool access near Countryside. Enjoy a comfortable lifestyle with convenient amenities in South Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "dog-park-apartments-moore-ok",
      "search_query": "dog park apartments Moore OK",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Moore, OK",
      "h2_subtitle": "Find pet-friendly living close to dog parks in Moore, OK. Countryside offers ideal amenities for you and your furry friends.",
      "page_copy": "While Countryside may not feature an on-site dog park, our pet-friendly community in Moore, OK, provides easy access to local dog parks in the vibrant South Oklahoma City area. Bringing your pet into our welcoming neighborhood means both of you can enjoy outdoor activities just minutes away.\n\nCountryside also offers excellent features like a smoke-free environment, a picnic area, and grilling facilities. Residents can take advantage of updated lighting in their apartments, ensuring a modern home experience, while select units include in-unit washer and dryers for additional convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Moore, OK",
      "seo_description": "Discover pet-friendly apartments near dog parks at Countryside in Moore, OK. Enjoy a welcoming community with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "spacious-bedroom-apartments-73160",
      "search_query": "spacious bedroom apartments 73160",
      "category": "Amenity",
      "h1_title": "Spacious Bedroom Apartments in 73160",
      "h2_subtitle": "Explore spacious bedroom apartments in the 73160 area. Countryside offers large living spaces in South Oklahoma City.",
      "page_copy": "At Countryside, we offer spacious bedroom apartments that cater to your need for comfort and roominess in the 73160 area. Located in the welcoming neighborhood of Moore, OK, our apartments are thoughtfully designed to provide generous living spaces that suit your lifestyle.\n\nResidents enjoy a variety of amenities, including a smoke-free environment, a grilling-friendly picnic area, and upgraded lighting in every unit. For added convenience, select apartments come equipped with in-unit washer and dryer. Countryside provides a perfect mix of spacious living in South Oklahoma City.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Bedroom Apartments in 73160",
      "seo_description": "Find spacious bedroom apartments in the 73160 area at Countryside. Experience comfortable living with modern amenities in Moore, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-oklahoma-city",
      "search_query": "one bedroom apartments south oklahoma city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South OKC",
      "h2_subtitle": "Discover one bedroom apartments in South Oklahoma City at Countryside. Designed for comfort and convenience, offering a perfect home base.",
      "page_copy": "Countryside offers charming one bedroom apartments in South Oklahoma City, perfect for individuals or couples seeking a cozy and convenient home. Nestled in Moore, OK, our community combines a serene environment with easy access to the vibrant South OKC lifestyle.\n\nResidents enjoy a smoke-free atmosphere, a communal picnic area, and grilling amenities for social gatherings. Updated lighting enhances the living spaces, and select units feature an in-unit washer and dryer, adding ease to daily life. Experience the best of South Oklahoma City living at Countryside.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in South OKC",
      "seo_description": "Explore one bedroom apartments in South Oklahoma City at Countryside. Enjoy modern living with convenient amenities in Moore, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-cleveland-county",
      "search_query": "two bedroom apartments cleveland county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Cleveland County",
      "h2_subtitle": "Explore spacious two bedroom apartments in Cleveland County at Countryside, providing a welcoming home for families and roommates alike.",
      "page_copy": "Located in Moore, OK, Countryside offers two bedroom apartments that are perfect for families or roommates seeking ample space in Cleveland County. Our community provides a blend of comfort and convenience with thoughtfully designed layouts.\n\nEnjoy our array of amenities, including a smoke-free atmosphere, a picnic area with grilling facilities, and updated lighting in each unit. Select apartments feature in-unit washers and dryers, enhancing your living experience. Discover a perfect blend of style and practicality at Countryside in Cleveland County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Cleveland County",
      "seo_description": "Find two bedroom apartments in Cleveland County at Countryside. Enjoy spacious living with modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "apartments-near-oklahoma-city-community-college",
      "search_query": "apartments near oklahoma city community college ok",
      "category": "School",
      "h1_title": "Apartments Near OKC Community College",
      "h2_subtitle": "Explore apartments near Oklahoma City Community College at Countryside. A perfect location for students and professionals alike.",
      "page_copy": "Countryside offers an ideal living option for those seeking apartments near Oklahoma City Community College (OKC Community College). Located in the vibrant area of Moore, OK, our community provides easy access to the college, making it convenient for students and faculty members.\n\nOur residents enjoy amenities such as a smoke-free environment, a lovely picnic area with grills, and updated lighting in every unit. Some apartments also feature an in-unit washer and dryer, adding extra convenience. Countryside ensures a comfortable and stylish living experience just a short drive from OKC Community College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OKC Community College",
      "seo_description": "Discover apartments near Oklahoma City Community College at Countryside. Convenient living in a fantastic location in Moore, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "apartments-close-to-mid-america-christian-university",
      "search_query": "apartments close to mid-america christian university moore",
      "category": "School",
      "h1_title": "Apartments Near Mid-America Christian University",
      "h2_subtitle": "Discover ideal apartments close to Mid-America Christian University at Countryside, perfect for students and faculty.",
      "page_copy": "Countryside offers attractive living solutions for those seeking apartments close to Mid-America Christian University in Moore, OK. Our community is perfect for university students and faculty looking for easy commutes.\n\nResidents of Countryside enjoy amenities including a smoke-free environment, a picnic area equipped with grills, and updated lighting throughout our units. Select apartments also come with in-unit washers and dryers, creating a convenient living experience. With its prime location and comfortable accommodations, Countryside is an ideal choice near Mid-America Christian University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Mid-America Christian University",
      "seo_description": "Find apartments near Mid-America Christian University in Moore at Countryside. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "apartments-by-christian-heritage-academy-cleveland-county",
      "search_query": "apartments by christian heritage academy cleveland county",
      "category": "School",
      "h1_title": "Apartments by Christian Heritage Academy",
      "h2_subtitle": "Explore living opportunities in Cleveland County with apartments by Christian Heritage Academy. Ideal for families and staff.",
      "page_copy": "Located in Moore, OK, Countryside offers convenient apartment living near Christian Heritage Academy in Cleveland County. Our community is well-suited for families and school staff seeking proximity to the academy.\n\nCountryside boasts a range of amenities including a smoke-free environment, picnic areas with grilling facilities, and modern updated lighting. Select units include a washer and dryer to enhance convenience. With its excellent location and community-focused features, Countryside is the perfect choice for living near Christian Heritage Academy in Cleveland County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Christian Heritage Academy",
      "seo_description": "Find apartments near Christian Heritage Academy in Cleveland County at Countryside. Ideal location with modern amenities in Moore, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "apartments-near-oklahoma-heart-hospital-south",
      "search_query": "apartments near Oklahoma Heart Hospital South in Cleveland County",
      "category": "Hospital",
      "h1_title": "Apartments Near Oklahoma Heart Hospital South",
      "h2_subtitle": "Discover comfortable apartments near Oklahoma Heart Hospital South in Cleveland County at Countryside, perfect for healthcare professionals.",
      "page_copy": "Countryside provides an ideal setting for those in search of apartments near Oklahoma Heart Hospital South, located in Cleveland County. Perfect for healthcare workers and their families, our community offers easy access to the hospital.\n\nOur residents enjoy a variety of amenities including a smoke-free environment, a welcoming picnic area with grills, and updated lighting fixtures throughout the complex. Selected units offer the convenience of in-unit washers and dryers. With its strategic location and modern features, Countryside ensures a pleasant living experience near Oklahoma Heart Hospital South.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oklahoma Heart Hospital South",
      "seo_description": "Explore apartments near Oklahoma Heart Hospital South in Cleveland County. Enjoy modern amenities and a prime location at Countryside.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "apartments-close-to-integris-health-southwest-moore",
      "search_query": "apartments close to INTEGRIS Health Southwest Medical Center Moore",
      "category": "Hospital",
      "h1_title": "Apartments Close to INTEGRIS Health Southwest",
      "h2_subtitle": "Find convenient living at Countryside with apartments close to INTEGRIS Health Southwest Medical Center in Moore, OK.",
      "page_copy": "At Countryside, we offer the perfect solution for those looking for apartments close to INTEGRIS Health Southwest Medical Center in Moore. Our location is ideal for health professionals and staff seeking a short commute.\n\nAmenities include a smoke-free environment, updated lighting, and a scenic picnic area complete with grills. Select units feature in-unit washers and dryers for added convenience. Situated in a prime location, Countryside provides a comfortable and accessible living option near INTEGRIS Health Southwest Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to INTEGRIS Health Southwest",
      "seo_description": "Discover apartments near INTEGRIS Health Southwest Medical Center in Moore, OK. Enjoy modern amenities and a convenient location at Countryside.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "apartments-near-scissortail-park-moore",
      "search_query": "apartments near scissortail park in moore",
      "category": "Park",
      "h1_title": "Apartments Near Scissortail Park",
      "h2_subtitle": "Live near Scissortail Park in Moore with vibrant apartment living at Countryside. Perfect for nature enthusiasts and families alike.",
      "page_copy": "Experience the best of nature and city living at Countryside, with our apartments conveniently located near Scissortail Park in Moore. The perfect choice for those who love outdoor activities and scenic walks.\n\nCountryside provides a serene, smoke-free environment enriched with amenities like updated lighting, a picnic area with grills, and washer/dryer options in some units. With its proximity to Scissortail Park, our community is ideal for families who appreciate spending time in the beautiful outdoors while enjoying the conveniences of modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Scissortail Park",
      "seo_description": "Explore apartments near Scissortail Park in Moore. Countryside offers a prime location with modern amenities for nature lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "apartments-close-to-buck-thomas-park-cleveland",
      "search_query": "apartments close to buck thomas park cleveland county",
      "category": "Park",
      "h1_title": "Apartments Close to Buck Thomas Park",
      "h2_subtitle": "Enjoy life near Buck Thomas Park in Cleveland County with modern living at Countryside Apartments, perfect for park enthusiasts.",
      "page_copy": "Countryside offers an ideal location for those looking for apartments close to Buck Thomas Park in Cleveland County. Enjoy the convenience of park amenities nearby while experiencing comfortable living in our community.\n\nOur community features a variety of amenities, including a smoke-free environment, an inviting picnic area with grills, and updated lighting throughout. Select units also feature the convenience of in-unit washer/dryer facilities. With its proximity to Buck Thomas Park, Countryside is a great choice for those who enjoy outdoor activities and modern apartment living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Buck Thomas Park",
      "seo_description": "Explore apartments near Buck Thomas Park in Cleveland County. Countryside features modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167073",
      "source": "generator",
      "page_item_url": "moore-apartments-by-little-river-park",
      "search_query": "moore apartments by little river park",
      "category": "Park",
      "h1_title": "Moore Apartments by Little River Park",
      "h2_subtitle": "Discover modern living in Moore with apartments by Little River Park, offering convenience and a vibrant community lifestyle.",
      "page_copy": "Discover Countryside, where you’ll find comfortable Moore apartments by Little River Park. It’s an ideal spot for those who cherish outdoor leisure and a thriving community vibe.\n\nOur community provides a serene, smoke-free environment with amenities like updated lighting and a charming picnic area with grills. Some units offer the convenience of in-unit washers and dryers. Just a short distance from Little River Park, Countryside provides the perfect blend of nature and modern apartment amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Moore Apartments by Little River Park",
      "seo_description": "Find Moore apartments near Little River Park at Countryside. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11307981291"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4057595434"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-57KHSC9P"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "ae948fc1-bfb0-45a6-bf2f-2c76448018d7"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/d7ff2487-29ad-445d-a3db-2b254dad15ae/app.js?property=d7ff2487-29ad-445d-a3db-2b254dad15ae&propertyName=Villas+at+Countryside+Apartment+Homes&channelUuid=c2491273-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "55606342929"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjZnZDdVWmRvWVhMbDEvVFRjTGVTeGc9PSIsInZhbHVlIjoiWjVRWEpOcWVmN2tJcS9DV3NkWGU3QT09IiwibWFjIjoiYzdlNTQ5YWMyODhkMWRkYmFjYTQ1OWQxM2ZkN2Q2ZjQzZmMzZTZjNDEwZjExYWNlYWY4MWYyNTMwZDg2NGM1YyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11307981291",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4057595434",
  "custom_google_gtm_id": "GTM-57KHSC9P",
  "custom_rollout_phase": "Phase 3",
  "custom_rentgrata_token": "ae948fc1-bfb0-45a6-bf2f-2c76448018d7",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/d7ff2487-29ad-445d-a3db-2b254dad15ae/app.js?property=d7ff2487-29ad-445d-a3db-2b254dad15ae&propertyName=Villas+at+Countryside+Apartment+Homes&channelUuid=c2491273-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "55606342929",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjZnZDdVWmRvWVhMbDEvVFRjTGVTeGc9PSIsInZhbHVlIjoiWjVRWEpOcWVmN2tJcS9DV3NkWGU3QT09IiwibWFjIjoiYzdlNTQ5YWMyODhkMWRkYmFjYTQ1OWQxM2ZkN2Q2ZjQzZmMzZTZjNDEwZjExYWNlYWY4MWYyNTMwZDg2NGM1YyJ9",
  "custom_audioeye_site_id": "07340487-61e6-4e76-b3c2-6c0010f249fc",
  "custom_audioeye_site_hash": "26cb6515ae4dca3830b649c45d9e556d"
};

export const generatedAt = '2026-10-27T17:15:42.827Z';
